<div>
    <div class="modal-header customBlueHeader">
        <p class="modal-title">Samples Collected</p>
        <button type="button" class="close" aria-label="Close" (click)="modelClose()">
      <span aria-hidden="true">&times;</span>
    </button>
    </div>

    <div class="modal-body customModalBody">

        <div class="row">
            <div class="col-md-4"><label>DD No</label></div>
            <div class="col-md-1"><label>:</label></div>
            <div class="col-md-7"><span>{{odid}}</span></div>
        </div>
        <div class="row">
            <div class="col-md-4"><label>Red-Serum</label></div>
            <div class="col-md-1"><label>:</label></div>
            <div class="col-md-1"><input type="radio" name="RadioOptions0"  (click)="choose_sampleoptiontype('RadioOptions0',$event)" value="0" checked="checked" >0</div>
            <div class="col-md-1"><input type="radio" name="RadioOptions0"  (click)="choose_sampleoptiontype('RadioOptions0',$event)" value="1">1</div>
            <div class="col-md-1"><input type="radio" name="RadioOptions0"  (click)="choose_sampleoptiontype('RadioOptions0',$event)" value="2">2</div>
            <div class="col-md-1"><input type="radio" name="RadioOptions0"  (click)="choose_sampleoptiontype('RadioOptions0',$event)"  value="3">3</div>
            <div class="col-md-1"><input type="radio" name="RadioOptions0"  (click)="choose_sampleoptiontype('RadioOptions0',$event)" value="4">4</div>
            <div class="col-md-1"><input type="radio" name="RadioOptions0"  (click)="choose_sampleoptiontype('RadioOptions0',$event)" value="5">5</div>
        </div>
        <div class="row">   
            <div class="col-md-4"><label>Grey-Sodium flurodie</label></div>
            <div class="col-md-1"><label>:</label></div>
            <div class="col-md-1"><input type="radio" name="RadioOptions1"  (click)="choose_sampleoptiontype('RadioOptions1',$event)" value="0"
                    checked="checked">0</div>
            <div class="col-md-1"><input type="radio" name="RadioOptions1"  (click)="choose_sampleoptiontype('RadioOptions1',$event)"  value="1">1</div>
            <div class="col-md-1"><input type="radio" name="RadioOptions1"  (click)="choose_sampleoptiontype('RadioOptions1',$event)"  value="2">2</div>
            <div class="col-md-1"><input type="radio" name="RadioOptions1"  (click)="choose_sampleoptiontype('RadioOptions1',$event)"  value="3">3</div>
            <div class="col-md-1"><input type="radio" name="RadioOptions1"  (click)="choose_sampleoptiontype('RadioOptions1',$event)"  value="4">4</div>
        </div>
        <div class="row">
            <div class="col-md-4"><label>Lavender - EDTA</label></div>
            <div class="col-md-1"><label>:</label></div>
            <div class="col-md-1"><input type="radio" name="RadioOptions2"  (click)="choose_sampleoptiontype('RadioOptions2',$event)"  value="0"
                    checked="checked">0</div>
            <div class="col-md-1"><input type="radio" name="RadioOptions2"  (click)="choose_sampleoptiontype('RadioOptions2',$event)"  value="1">1</div>
            <div class="col-md-1"><input type="radio" name="RadioOptions2"  (click)="choose_sampleoptiontype('RadioOptions2',$event)" value="2">2</div>
            <div class="col-md-1"><input type="radio" name="RadioOptions2"  (click)="choose_sampleoptiontype('RadioOptions2',$event)"  value="3">3</div>
        </div>
        <div class="row">
            <div class="col-md-4"><label>Blue-Sodium citrate</label></div>
            <div class="col-md-1"><label>:</label></div>
            <div class="col-md-1"><input type="radio" name="RadioOptions3"  (click)="choose_sampleoptiontype('RadioOptions3',$event)"  value="0"
                    checked="checked">0</div>
            <div class="col-md-1"><input type="radio" name="RadioOptions3"  (click)="choose_sampleoptiontype('RadioOptions3',$event)"  value="1">1</div>
            <div class="col-md-1"><input type="radio" name="RadioOptions3"  (click)="choose_sampleoptiontype('RadioOptions3',$event)" value="2">2</div>
        </div>
        <div class="row">
            <div class="col-md-4"><label>Black-ESR</label></div>
            <div class="col-md-1"><label>:</label></div>
            <div class="col-md-1"><input type="radio" name="RadioOptions4"  (click)="choose_sampleoptiontype('RadioOptions4',$event)"  value="0"
                    checked="checked">0</div>
            <div class="col-md-1"><input type="radio" name="RadioOptions4"  (click)="choose_sampleoptiontype('RadioOptions4',$event)"  value="1">1</div>
        </div>
        <div class="row">
            <div class="col-md-4"><label>Urine Container-30 ML</label></div>
            <div class="col-md-1"><label>:</label></div>
            <div class="col-md-1"><input type="radio" name="RadioOptions5"  (click)="choose_sampleoptiontype('RadioOptions5',$event)"  value="0"
                    checked="checked">0</div>
            <div class="col-md-1"><input type="radio" name="RadioOptions5"  (click)="choose_sampleoptiontype('RadioOptions5',$event)"  value="1">1</div>
        </div>
        <div class="row">
            <div class="col-md-4"><label>Stool Container-30 ML</label></div>
            <div class="col-md-1"><label>:</label></div>
            <div class="col-md-1"><input type="radio" name="RadioOptions6"  (click)="choose_sampleoptiontype('RadioOptions6',$event)"  value="0"
                    checked="checked">0</div>
            <div class="col-md-1"><input type="radio" name="RadioOptions6"  (click)="choose_sampleoptiontype('RadioOptions6',$event)"  value="1">1</div>
        </div>
        <div class="row">
            <div class="col-md-4"><label>Green-Heparin</label></div>
            <div class="col-md-1"><label>:</label></div>
            <div class="col-md-1"><input type="radio" name="RadioOptions7"  (click)="choose_sampleoptiontype('RadioOptions7',$event)"  value="0"
                    checked="checked">0</div>
            <div class="col-md-1"><input type="radio" name="RadioOptions7"  (click)="choose_sampleoptiontype('RadioOptions7',$event)"  value="1">1</div>
        </div>
        <div class="row">
            <div class="col-md-4"><label>Sputurm Container</label></div>
            <div class="col-md-1"><label>:</label></div>
            <div class="col-md-1"><input type="radio" name="RadioOptions8"  (click)="choose_sampleoptiontype('RadioOptions8',$event)"  value="0"
                    checked="checked">0</div>
            <div class="col-md-1"><input type="radio" name="RadioOptions8"  (click)="choose_sampleoptiontype('RadioOptions8',$event)"  value="1">1</div>
        </div>
        <div class="row">
            <div class="col-md-4"><label>Green-Aerobic</label></div>
            <div class="col-md-1"><label>:</label></div>
            <div class="col-md-1"><input type="radio" name="RadioOptions9"  (click)="choose_sampleoptiontype('RadioOptions9',$event)"  value="0"
                    checked="checked">0</div>
            <div class="col-md-1"><input type="radio" name="RadioOptions9"  (click)="choose_sampleoptiontype('RadioOptions9',$event)"  value="1">1</div>
        </div>
        <div class="row">
            <div class="col-md-4"><label>Orange-Anarobic</label></div>
            <div class="col-md-1"><label>:</label></div>
            <div class="col-md-1"><input type="radio" name="RadioOptions10"  (click)="choose_sampleoptiontype('RadioOptions10',$event)" value="0"
                    checked="checked">0</div>
            <div class="col-md-1"><input type="radio" name="RadioOptions10"  (click)="choose_sampleoptiontype('RadioOptions10',$event)"  value="1">1</div>
        </div>
        <div class="row">
            <div class="col-md-4"><label>Urine Container-5 L</label></div>
            <div class="col-md-1"><label>:</label></div>
            <div class="col-md-1"><input type="radio" name="RadioOptions11"  (click)="choose_sampleoptiontype('RadioOptions11',$event)"  value="0"
                    checked="checked">0</div>
            <div class="col-md-1"><input type="radio" name="RadioOptions11"  (click)="choose_sampleoptiontype('RadioOptions11',$event)"  value="1">1</div>
        </div>
        <div class="row">
            <div class="col-md-4"><label>Yellow-SST GEL</label></div>
            <div class="col-md-1"><label>:</label></div>
            <div class="col-md-1"><input type="radio" name="RadioOptions12"  (click)="choose_sampleoptiontype('RadioOptions12',$event)"  value="0"
                    checked="checked">0</div>
            <div class="col-md-1"><input type="radio" name="RadioOptions12"  (click)="choose_sampleoptiontype('RadioOptions12',$event)"  value="1">1</div>
        </div>
        <div class="row">
            <div class="col-md-4"><label>Viral Transport Media (VTM)</label></div>
            <div class="col-md-1"><label>:</label></div>
            <div class="col-md-1"><input type="radio" name="RadioOptions13" (click)="choose_sampleoptiontype('RadioOptions13',$event)"  value="0"
                    checked="checked">0</div>
            <div class="col-md-1"><input type="radio" name="RadioOptions13" (click)="choose_sampleoptiontype('RadioOptions13',$event)"  value="1">1</div>
            <div class="col-md-1"><input type="radio" name="RadioOptions13" (click)="choose_sampleoptiontype('RadioOptions13',$event)"  value="2">2</div>
            <div class="col-md-1"><input type="radio" name="RadioOptions13" (click)="choose_sampleoptiontype('RadioOptions13',$event)"  value="3">3</div>
        </div>
        <div class="row">
            <div class="col-md-4"><label>Barcode</label></div>
            <div class="col-md-1"><label>:</label></div>
            <div class="col-md-1">
                <input type="textbox"  placeholder="Enter Barccode" [formControl]="isbarcode" value="{{barcode}}">
            </div>
        </div>
    </div>
      <div class="modal-footer customModalFooter customModalFooter">
        <button type="submit" class="btn green_btn" (click)="samplecollectionSubmission()">Submit</button>
        <button type="button" class="btn danger_btn" (click)="modelClose()">Cancel</button>
      </div>
</div>